import { BeneficialOwnerData } from '../../BeneficialOwners';

export default function generateBeneficialOwners(
  beneficialOwnersData: Required<BeneficialOwnerData>[],
  formValues: Record<string, string>,
): Record<string, string | boolean | number | Address | Dob>[] {
  return beneficialOwnersData.map((bo) => ({
    firstName: formValues[`beneficialOwner${bo.internalId}KycFirstName`],
    lastName: formValues[`beneficialOwner${bo.internalId}KycLastName`],
    phoneNumber: formValues[`beneficialOwner${bo.internalId}KycPhoneNumber`],
    email: formValues[`beneficialOwner${bo.internalId}KycEmail`],
    ssn: formValues[`beneficialOwner${bo.internalId}KycSsn`],
    owner: true,
    percentOwnership: bo.percentOwnership,
    dob: {
      month: formValues[`beneficialOwner${bo.internalId}KycDobMonth`],
      day: formValues[`beneficialOwner${bo.internalId}KycDobDay`],
      year: formValues[`beneficialOwner${bo.internalId}KycDobYear`],
    },
    address: {
      street: formValues[`beneficialOwner${bo.internalId}KycAddressStreet`],
      unit: formValues[`beneficialOwner${bo.internalId}KycAddressUnit`],
      city: formValues[`beneficialOwner${bo.internalId}KycAddressCity`],
      region: bo.addressRegion,
      postalCode:
        formValues[`beneficialOwner${bo.internalId}KycAddressPostalCode`],
    },
  }));
}
